import { DraggerRule } from '@/components/common/Dragger';

import CommonModal from '../index';

export type DraggerSlot = JSX.Element | (() => JSX.Element);
export type UploadWorkspace = 'video' | 'script' | 'audio' | 'image';
import dynamic from 'next/dynamic';
import React from 'react';

import { UploadEventTracking } from './components/uploadList';

const Content = dynamic(() => import('./content'), { ssr: false });

export interface UploadModal {
  title: string;
  workspace: UploadWorkspace;
  rules: DraggerRule[];
  draggerSlot: DraggerSlot;
  onClose: () => void;
  onEventTracking?: UploadEventTracking;
}

export function UploadModalShow(options: UploadModal) {
  const { title, onClose: onUploadModalClose } = options;
  CommonModal.show((t) => ({
    width: 690,
    title,
    footer: false,
    content: (close) => {
      return (
        <Content
          {...options}
          onClose={() => {
            // 关闭commonModal自身弹窗
            close();
            // 关闭上传弹窗的回调
            onUploadModalClose();
          }}
        />
      );
    },
  }));
}
